(ns com.theplantscape.web-ui.tailwind.info-tile
  (:require [com.theplantscape.web-ui.tailwind.images :refer [picture]]))

(defn ui-info-tile [{:keys [title path image description] :or
                   {title "Title text here"
                    description [:p.mt-4  "Description here"]}}]
  [:div.tps-secondary.rounded-3xl.background-blue-200.m-auto
   [:div.flex
    [picture {:image (or image "https://img.theplantscape.com/api/image/do/404-image-01.jpg?p=h-192")}]
    [:div.ml-4 {:class "w-2/3"}
     [:h1.text-3xl title]
     (when path
       [:p.mt-4 (str path)])
     (if (seq description)
       (into [:div] (mapv (fn [line] [:p (str (:msg line))]) description))
       description)]]])


(defn ui-stat-tile [{:keys [value text icon]}] 
  [:a {:href "#" :class "flex h-20 w-40 flex-col items-center justify-center rounded-md border border-dashed border-gray-200 transition-colors duration-100 ease-in-out hover:border-gray-400/80"}
   [:div.flex.flex-row.items-center.justify-center
    icon
    #_[:svg {:class "mr-3 fill-gray-500/95" :xmlns "http://www.w3.org/2000/svg" :xmlns:xlink "http://www.w3.org/1999/xlink" :version "1.1" :width "24" :height "24" :viewBox "0 0 24 24"}
     [:path {:d "M12,23A1,1 0 0,1 11,22V19H7A2,2 0 0,1 5,17V7A2,2 0 0,1 7,5H21A2,2 0 0,1 23,7V17A2,2 0 0,1 21,19H16.9L13.2,22.71C13,22.89 12.76,23 12.5,23H12M13,17V20.08L16.08,17H21V7H7V17H13M3,15H1V3A2,2 0 0,1 3,1H19V3H3V15M9,9H19V11H9V9M9,13H17V15H9V13Z"}]]
    [:div.ml-2.font-bold.text-gray-600 value]]
   [:div.mt-2.text-sm.text-gray-400 text]])
